import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import SectionLink from "../common/SectionLink";
import pages from "../../data/pages.json";
import "./Footer.css";

const Footer = () => (
  <footer className="lk-footer">
    <div className="lk-container">
      <div className="lk-footer-top">
        <div className="lk-footer-brand">
          <span className="lk-brand-mark lk-footer-mark">
            <img src={logo} alt="" />
          </span>
          <div>
            <strong>Lankovate</strong>
            <p>Software for growing businesses. Built in Sri Lanka.</p>
          </div>
        </div>
        <nav className="lk-footer-nav" aria-label="Services">
          {pages.services.map((s) => (
            <Link key={s.path} to={s.path}>{s.name}</Link>
          ))}
        </nav>
        <nav className="lk-footer-nav" aria-label="Footer">
          <SectionLink to="process">How we work</SectionLink>
          <SectionLink to="about">Why us</SectionLink>
          <a href="#contact">Contact</a>
        </nav>
      </div>
      <div className="lk-footer-bottom">
        <span>© {new Date().getFullYear()} Lankovate Technologies. All rights reserved.</span>
        <span>
          Odoo is a trademark of Odoo S.A. Lankovate is an independent
          development company.
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
